import { Box } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { IDocumentListItem } from "source/models/document/documentListItem";
import { AttachmentIcon } from "source/components/attachments/AttachmentIcon";
import { FileType, Permission } from "ui/Scripts/source/models/enums";
import { ListStateIconBall } from "source/components/framework/List/ListStateIconBall";
import { ListStateIconSuccess } from "source/components/framework/List/ListStateIconSuccess";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { DocumentListLinePopuMenu } from "./DocumentListLinePopuMenu";
import { ListStateIconUnpublished } from "source/components/framework/List/ListStateIconUnpublished";

interface IDocumentListLineFirstColumnProps {
    item: IDocumentListItem;
    documentStyle: any;
    editMode: boolean;
    folderPermission: Permission;
    isSelected: boolean;
    canDownloadSelectedDocuments: boolean;
    canPrintSelectedDocuments: boolean;
    onCopyMoveSelectedDocuments: () => void;
    onOpenOpenDocument: (id: string) => void;
    onOpenSelectedDocument: () => void;
    onDownloadSelectedDocuments: () => void;
    onPrintSelectedDocuments: () => void;
    onDeleteSelectedDocuments: () => Promise<void>;
}

export const DocumentListLineFirstColumn = (props: IDocumentListLineFirstColumnProps) => {
    const [hovered, setHovered] = React.useState(false);

    const item = props.item;

    return (
        <Box
            display="flex"
            alignItems="center"
            overflow="hidden"
            title={item.code + (item.comment ? "\n\n" + item.comment : "")}
            width="100%"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Box sx={props.documentStyle}>
                {(item.image
                    ? <AvatarImage id={""} image={item.image} />
                    : <AttachmentIcon fileType={item.fileType} color="#E9F0FA" strokeColor="#848688" />
                )}
            </Box>
            <Box sx={{ marginLeft: "4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", ...props.documentStyle }}>{item.code}</Box>
            {!!item.publishedId && item.fileType === FileType.Document &&
                <div style={{ marginLeft: "auto" }}>
                    {(item.publishedDate && item.publishedDate < props.item.modifyUser.date
                        ? <ListStateIconUnpublished tooltip={Translations.DocumentHasBeenModifiedAfterItWasPublished} />
                        : (item.publishedApproved
                            ? <ListStateIconSuccess tooltip={Translations.Published + ", " + Translations.Approved} />
                            : <ListStateIconBall tooltip={Translations.Published} />
                        )
                    )}
                </div>
            }
            {hovered &&
                <DocumentListLinePopuMenu
                    isSelected={props.isSelected}
                    editMode={props.editMode}
                    folderPermission={props.folderPermission}
                    canDownloadSelectedDocuments={props.canDownloadSelectedDocuments}
                    canPrintSelectedDocuments={props.canPrintSelectedDocuments}
                    onCopyMoveSelectedDocuments={props.onCopyMoveSelectedDocuments}
                    onOpenSelectedDocument={props.onOpenSelectedDocument}
                    onDownloadSelectedDocuments={props.onDownloadSelectedDocuments}
                    onPrintSelectedDocuments={props.onPrintSelectedDocuments}
                    onDeleteSelectedDocuments={props.onDeleteSelectedDocuments}
                />
            }
        </Box>
    );
};
